import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BRAND = { color: '#1e3a5f' };

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <nav className="border-b border-slate-200 bg-white">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-3">
          <Button variant="ghost" size="sm" onClick={() => navigate('/')}><ArrowLeft className="w-4 h-4 mr-1" />Volver</Button>
          <div className="flex items-center gap-2">
            <img src="/macropago-logo.jpeg" alt="MacroPago" className="w-8 h-8 rounded-lg object-cover" />
            <span className="text-lg font-bold" style={{ color: BRAND.color, fontFamily: 'Manrope' }}>MacroPago</span>
          </div>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope' }}>Politica de Privacidad</h1>
        <p className="text-sm text-slate-500 mb-8">Ultima actualizacion: Febrero 2026</p>

        <div className="prose prose-slate max-w-none space-y-6 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">1. Informacion que Recopilamos</h2>
            <p>MacroPago recopila informacion necesaria para la prestacion del servicio de gestion de cobranzas:</p>
            <ul className="list-disc pl-6 space-y-1 text-sm">
              <li><strong>Datos de empresas:</strong> Razon social, CUIT, email del responsable, datos bancarios para cobros.</li>
              <li><strong>Datos de clientes:</strong> Nombre, DNI/CUIT, domicilio, email, telefono, monto de deuda, historial de pagos.</li>
              <li><strong>Datos de uso:</strong> Tipo de dispositivo, navegador, fecha y hora de acceso, acciones realizadas en la plataforma.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">2. Uso de la Informacion</h2>
            <p>Utilizamos la informacion recopilada para:</p>
            <ul className="list-disc pl-6 space-y-1 text-sm">
              <li>Prestar el servicio de gestion de cobranzas contratado por la empresa.</li>
              <li>Facilitar la consulta y pago de deudas por parte de los clientes.</li>
              <li>Enviar comunicaciones relacionadas con la gestion de cobro (WhatsApp, email).</li>
              <li>Generar reportes y analytics para las empresas contratantes.</li>
              <li>Mejorar la plataforma y la experiencia del usuario.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">3. Almacenamiento y Seguridad</h2>
            <p>Los datos se almacenan en servidores seguros con cifrado en transito (TLS/SSL). Implementamos medidas tecnicas y organizativas para proteger la informacion contra acceso no autorizado, alteracion o perdida.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">4. Compartir Informacion</h2>
            <p>No vendemos ni compartimos datos personales con terceros, excepto:</p>
            <ul className="list-disc pl-6 space-y-1 text-sm">
              <li>Procesadores de pago (Mercado Pago) para ejecutar transacciones.</li>
              <li>Proveedores de mensajeria (WhatsApp/UltraMSG) para comunicaciones de cobro.</li>
              <li>Cuando sea requerido por ley o autoridad competente.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">5. Derechos del Titular</h2>
            <p>Conforme a la Ley 25.326 de Proteccion de Datos Personales de Argentina, los titulares tienen derecho a acceder, rectificar y suprimir sus datos personales. Para ejercer estos derechos, contactanos a traves de nuestros canales de atencion.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">6. Cookies</h2>
            <p>Utilizamos cookies de sesion para mantener la autenticacion del usuario y cookies analiticas para mejorar la experiencia de uso. No utilizamos cookies de seguimiento publicitario.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">7. Contacto</h2>
            <p>Para consultas sobre esta politica de privacidad, contactanos en: <strong>macropago.com.ar</strong></p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
